import { useAppStore } from "@/store/app";
import { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import NotFound from "./not-found";
import Register from "./auth/register";
import ContentPage from "./content-page";
import LandingPage from "./landing-page";

export default function DynamicPage() {
  const location = useLocation();
  const { presets } = useAppStore();

  const RenderPage = useCallback(() => {
    if (!presets) return;

    console.log("RenderPage", location.pathname);

    const item = presets?.menu?.value?.find((item: any) => {
      return item?.route === location.pathname;
    });

    if (!item) {
      return <NotFound />;
    }

    switch (item?.pageType) {
      case "content":
        return <ContentPage data={item} />;
        break;
      case "registration":
        return <Register />;
      case "landing_page":
        return <LandingPage />;
      default:
        return <NotFound />;
    }
  }, [location, presets]);

  return useMemo(() => {
    if (presets) {
      return RenderPage();
    }
    return (
      <div className="p-8 prose">
        <h3>Loading...</h3>
      </div>
    );
  }, [presets, RenderPage]);
}
